import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

import { useCreateAgentEligibility } from './useCreateAgentEligibility.ts';

type UseCreateAgentEntryPointArgs = {
	source: string;
	isMenuOpen?: boolean;
};

type UseCreateAgentEntryPointResult = {
	shouldRenderInlineCreateAgentItem: boolean;
	shouldRenderStudioRedirectCreateAgentItem: boolean;
	isLoading: boolean;
};

export const useCreateAgentEntryPoint = ({
	source,
	isMenuOpen = true,
}: UseCreateAgentEntryPointArgs): UseCreateAgentEntryPointResult => {
	const { isEligible: isAgentCreationEligible, isLoading } = useCreateAgentEligibility({
		source,
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		skip: !isMenuOpen || !fg('cc_fd_agent_creation_connie_create_gate'),
	});

	// Keep the item's slot rendered as a loading placeholder while resolving.
	const shouldRenderInlineCreateAgentItem =
		(isAgentCreationEligible || isLoading) &&
		expValEquals('cc_inline_agent_create', 'isEnabled', true);

	const shouldRenderStudioRedirectCreateAgentItem =
		(isAgentCreationEligible || isLoading) &&
		expValEquals('cc_fd_agent_creation_connie_create', 'isEnabled', true);

	return {
		shouldRenderInlineCreateAgentItem,
		shouldRenderStudioRedirectCreateAgentItem,
		isLoading,
	};
};
